import { TResponseListWrapper, TResponseItemWrapper } from "../common/types/common";

export const getResponseData = <T>(response: TResponseListWrapper<T>) => ({
    data: response?.data?.data,
    meta: response?.data ? {
        totalRecords: response?.data?.totalRecords
    } : null,
});

export const getResponseItemData = <T>(response: TResponseItemWrapper<T>) => ({
    data: response?.data || null,
});
